import { CommonStateEnum, SourceTypeEnum } from "./common";
import { PurchaseOrder, PurchaseOrderItem, Supplier } from "@/types/purchase";
import { Product, StoreTypeEnum } from "./product";
import { ScanItem } from "./scan";
import { User } from "./user";

/**
 * v2版本的type（orderType）
 * 
 * v1的changeType
 */
export enum ChangeEnum {
  PRE_IN = 4, // 预入库
  PRE_OUT = 5, // 预出库
  IN = 6, // 入库
  OUT, // 出库
  ORDER_IN = 1, // 采购单入库
  TEMP_IN = 3, //临时入库 
  TEMP_OUT = 2, //临时出库
  SALES_OUT = 8, //销售单出库

  SPEC_OUT = 99, //假值
  PROD_IN = 100, //假值
  PROD_TEMP_IN = 101, //假值
  SHIPMENT_OUT, //假值
}


export enum OperateEnum2 {
  SURPLUS = 1,      //正常结余退库
  DEFECTIVE = 2,    //不良品退库
  REFURBISHED = 3,    //不良品加工
  REOUTRECVD = 4, //误出库领料
}

export enum OperateEnum {
  PENDING = 1, //盘点,盘点入库和盘点出库
  TRANSACTION, //交易,采购入库和销售出库
  DISPATCH, //调拨,货物调度出库, 其他仓库出库单货物入库
  TEMPORARY, //临时
  PICKING, // 领料
  IN_RETURN, // 入库单退回
  OUT_RETURN, // 出库单退回
  PROD_IN, // 生产入库
  MATERIAL_OVER_ISSUE = 10, // 超领领料
  SHIPMENT_OUT, // 发货出库
}

export enum OrderEnum {
  SCAN = 1, //扫描单
  COUNT, //数量单
}

export enum CountingStateEnum {
  PENDING, //生成盘点单
  COUNTING, //计数，生成差异中
  IN, //完成差异入库
  OUT, //完成差异出库
  DONE = 5,
}

export enum ConfirmedEnum {
  NOTCONFIRM, //未确认
  CONFIRM, //确认
}

export interface Inventory {
  id: string;
  productId: string;
  quantity: number;
  product: Product;
  barcodes?: Array<Barcodes>;
  his?: Array<His>;
  state?: CommonStateEnum;
  supplier?: Supplier;
  preIn: number;
  preOut: number;
}

export interface His {
  id: string;
  inventoryId: string;
  inventoryOrderId: string;
  inventoryOrderItemId: string;
  changeType: ChangeEnum;
  changeSource: string;
  quantity: number;
  reQuantity: number;
  inventoryOrder: Order;
  inventoryOrderItem: OrderItem;
  state: CommonStateEnum;
}

export interface Order {
  id: string;
  orgId: string;
  number: string;
  source: PurchaseOrderItem,
  changeType: ChangeEnum;
  sourceType: SourceTypeEnum | null;
  opType: OperateEnum;
  sourceId: string;
  confirmed: ConfirmedEnum;
  orderType: OrderEnum;
  items: Array<OrderItem>;
  scans: Array<ScanItem>;
  state: CommonStateEnum;
  creator: User;
  createdAt: number;
  preTime: number;    //送货时间
  returnOrderId: string;
  arrivalAt?: number;
}

export interface OrderItem {
  id?: string;
  productId: string;
  quantity: number;
  product: Product;
  barcodes?: Array<Barcodes>;
}

export interface Barcodes {
  id: string;
  barcode: string
}

export interface CountingOrder {
  id: string;
  number: string;
  orderState: CountingStateEnum;
  items: Array<CountingItem>;
  scans: Array<ScanItem>;
  state: CommonStateEnum;
  creator: User;
  createdAt: number;
}

export interface CountingItem {
  id: string;
  orderId: string;
  productId: string;
  counting: string;
  stock: string;
  countingBarcodes: Array<string>;
  stockBarcodes: Array<string>;
  product: Product;
  barcode?: string;
}

export interface OrderAdd {
  arrivalAt: number | null;
  changeType: ChangeEnum;
  sourceType: SourceTypeEnum;
  opType: OperateEnum;
  sourceId: string;
  items: Array<OrderAddItem>;
  scans: Array<string>;
  preTime?: number | null;
  orderType: StoreTypeEnum;
  returnOrderId?: string;
}

export interface OrderAddItem {
  productId: string;
  quantity: number;
}

export interface CountingOrderAddItem {
  productId: string;
  counting: number;
}

export interface CountingOrderAdd {
  items: Array<CountingOrderAddItem>;
  scans: Array<string>;
}

export interface CountingOrderAddItem {
  productId: string;
  counting: number;
}

export interface CountingDifferenceCountItem {
  count: number;
  product: Product | null;
  productId: string;
}

export interface CountingDifference {
  errors: Array<CountingDifferenceItem>;
  scans: Array<CountingDifferenceItem>;
  stocks: Array<CountingDifferenceItem>;
  countingCount: Array<CountingDifferenceCountItem> | null;
  stockCount: Array<CountingDifferenceCountItem> | null;
}

export interface CountingDifferenceItem extends Barcodes {
  productId: string;
  product: Product;
  // errors 字段
  orderItemId?: string;
  orderProduct?: Product;
  orderProductId?: string;
  stockProduct?: Product;
  stockProductId?: string;
}